import React from "react";
import spinnerImage from "./images/ring.gif";
import "./css/Ring.scss";
import "./css/common-loader.scss";

const Ring = ({ height = 150, width = 150, color = "green", fullscreen }) =>
  (fullscreen ? buildFullScreenHtml : buildInlineScreenHtml)({
    height,
    width,
    color
  });

const buildFullScreenHtml = props => (
  <div className="bfl-loader-wrapper">
    <div className="loader-container">
      <img
        alt="load"
        src={spinnerImage}
        style={{ height: props.height, width: props.width }}
      />
    </div>
  </div>
);

const buildInlineScreenHtml = props => (
  <div className="inline-loader-container">
    <img
      alt="load"
      src={spinnerImage}
      style={{ height: props.height, width: props.width }}
    />
  </div>
);

export default Ring;
